"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var SalesRepResource = /** @class */ (function (_super) {
    tslib_1.__extends(SalesRepResource, _super);
    function SalesRepResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesRepResource.endpoint = '/salesreps';
    SalesRepResource.MODEL_NAME = 'salesrep';
    return SalesRepResource;
}(base_1.default));
exports.default = SalesRepResource;
//# sourceMappingURL=salesrep.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/salesrep.js
// module id = OAOm
// module chunks = 0